import 'antd/dist/reset.css'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import * as serviceWorker from './serviceWorker'
import store from 'store'
import { AUTH_TOKEN } from 'constants/AuthConstant'
import { getMe, signInSuccess } from 'store/slices/identitySlice'
import IdentityService from 'services/IdentityService'
import ReactPixel from 'react-facebook-pixel'
import { env } from 'configs/EnvironmentConfig'
import TagManager from 'react-gtm-module'

function setAccessToken() {
  const urlParams = new URLSearchParams(window.location.search)
  const access_token = urlParams.get('access_token')
  if (access_token) {
    localStorage.setItem(AUTH_TOKEN, access_token)
    window.history.replaceState({}, '', window.location.pathname)
  }
}

async function configureActivation() {
  const urlParams = new URLSearchParams(window.location.search)
  const code = urlParams.get('activation_code')

  if (code) {
    window.history.replaceState({}, '', window.location.pathname)
    try {
      const response = await IdentityService.verify(code)
      if (response.status === 200) {
        localStorage.removeItem(AUTH_TOKEN)
        const refreshResponse = await IdentityService.refreshToken()
        if (refreshResponse.status === 200) {
          localStorage.setItem(AUTH_TOKEN, refreshResponse.data.access_token)
        }
        sessionStorage.setItem('notification', 'Conta ativada com sucesso')
      } else {
        sessionStorage.setItem(
          'notification',
          'Você precisa estar logado para acessar utilizar o link de ativação. Faça o login e acesse o link de ativação.'
        )
      }
    } catch (error) {
      console.log(error)
    }
  }
}

function configureMe() {
  const jwtToken = localStorage.getItem(AUTH_TOKEN)
  if (jwtToken) {
    store.dispatch(signInSuccess(jwtToken))
    store.dispatch(getMe())
  }
}

function configurePixel() {
  if (!env.PIXEL_ID) return

  ReactPixel.init(env.PIXEL_ID)
  ReactPixel.pageView()
}

function configureTagManager() {
  if (!env.GOOGLE_TAG_MANAGER_ID) return

  TagManager.initialize({
    gtmId: env.GOOGLE_TAG_MANAGER_ID,
  })
}

async function initializeApp() {
  await configureActivation()
  setAccessToken()
  configureMe()
  configurePixel()
  configureTagManager()

  const container = document.getElementById('root')
  const root = createRoot(container)
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
}

initializeApp()

serviceWorker.unregister()
